import { REQUESTING_PLATFORM_TO_CODES } from '../constants/requesting-platform';

const PLATFORM_DOCUMENT_CONFIG = {
  [REQUESTING_PLATFORM_TO_CODES.BCH]: {
    contract: {
      shouldShowAsReadyButDisabled: (company, hasRealPdfDocument) => {
        const hasFrameworkContract = company?.hasFrameworkContract;
        return hasFrameworkContract && !hasRealPdfDocument;
      },
      getCredentials: (company) => {
        if (company?.hasFrameworkContract) {
          return [
            {
              key: 'Estado:',
              value: 'Documento disponible',
            },
          ];
        }
        return [
          {
            key: 'Actualizado al:',
            value: 'N/D',
          },
        ];
      },
      isDisabled: true,
      disabledTooltipText: 'El documento no está disponible para descarga',
    },
  },
};

const getPlatformDocumentConfig = (requestingPlatform, documentType) => {
  if (!documentType || !requestingPlatform) {
    return null;
  }
  return PLATFORM_DOCUMENT_CONFIG[requestingPlatform]?.[documentType] || null;
};

export const shouldShowDocumentAsReadyButDisabled = (
  requestingPlatform,
  documentType,
  company,
  hasRealPdfDocument,
) => {
  const config = getPlatformDocumentConfig(requestingPlatform, documentType);
  if (!config) {
    return false;
  }
  return config.shouldShowAsReadyButDisabled(company, hasRealPdfDocument);
};

export const getDocumentCredentialsForPlatform = (
  requestingPlatform,
  documentType,
  company,
) => {
  const config = getPlatformDocumentConfig(requestingPlatform, documentType);
  if (!config || !config.getCredentials) {
    return null;
  }
  return config.getCredentials(company);
};

export const isDocumentDisabledForPlatform = (
  requestingPlatform,
  documentType,
) => {
  const config = getPlatformDocumentConfig(requestingPlatform, documentType);
  return config?.isDisabled || false;
};

export const getDocumentDisabledTooltipForPlatform = (
  requestingPlatform,
  documentType,
) => {
  const config = getPlatformDocumentConfig(requestingPlatform, documentType);
  return config?.disabledTooltipText || null;
};
